var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Grid',_vm._b({attrs:{"events":_vm.events,"date-format":"DATE_MED","separate-year":false}},'Grid',_vm.gridOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }